import { AxiosResponse, CancelTokenSource } from 'axios';
import { FilterType } from '../enums/FilterType';
import API from './index';

const api = new API();

export type FilterItemType = { id: number; name: string; type: FilterType };
export type FilterAreaType = { name: string; cityIds: number[] };

export const getFiltersInUse: (cancelToken: CancelTokenSource) => Promise<
  AxiosResponse<{
    occasions: FilterItemType[];
    categories: FilterItemType[];
    cities: FilterItemType[][];
    areas: FilterAreaType[];
  }>
> = (cancelToken) => {
  return api._get('/web/filter/inuse', { cancelToken: cancelToken.token });
};
